import {
  Container,
  Dimmer,
  Grid,
  Table,
  Loader,
  Segment,
  Item,
  Label,
  Checkbox,
  Menu,
  Button,
} from 'semantic-ui-react';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { decodeSearch, encodeSearch, AWSUrl } from '../../utils/url';
import isbase64 from '../../utils/isbase64';
import { SearchList } from '../../components/Filters';
import Timestamp from '../../components/Timestamp';
import PageNav from '../../components/PageNav';
import NavBar from '../../components/NavBar';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';

class Accounting extends Component {
  static contextTypes = {
    appConfig: PropTypes.shape({}),
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const advanceFilter = false;
    const projectFilter = (isbase64(query.projectFilter) && qs.parse(atob(query.projectFilter)).name) || '';
    return {
      currentPage,
      search,
      advanceFilter,
      projectFilter,
      loadingSearch: false,
      findProjectResults: [],
      noResultsMessage: 'Loading...',
    };
  }
  constructor(props) {
    super(props);
    const state = Accounting.getPropsToState(props);
    state.data = [];
    this.state = {
      loading: true,
      count: 0,
      limit: 10,
      offset: 0,
      token: '',
      ...state,
    };
    const query = decodeSearch(props.location.search);
    if ((query.projectFilter && query.projectFilter.length > 0)) {
      this.state.advanceFilter = true;
    }
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    this.fetchBookings(query);
  }
  componentWillReceiveProps(nextProps) {
    const state = Accounting.getPropsToState(nextProps);
    const query = decodeSearch(nextProps.location.search);
    if (this.state.limit < 0) {
      this.fetchBookings(query);
      state.loading = this.state.loading;
    }
    state.token = this.state.token;
    if ((query.projectFilter && query.projectFilter.length > 0)) {
      state.advanceFilter = true;
    }
    this.setState({ ...state });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoadingSearch(loadingSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingSearch }, res);
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  setBookings(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  async fetchBookings(q = {}) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign(q, this.props.where || {});
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/noetic/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const token = res.headers.get('X-CSRF-Token');
      const data = await res.json();
      let newData = [];
      if (data) {
        newData = data;
        data.forEach((d, idx) => {
          newData[idx].send = false;
        });
      }
      await this.setBookings(newData);
      if (this.state.data.length < 1 && query.page > 1) {
        const que = decodeSearch(this.props.location.search);
        que.page = 1;
        this.replaceQuery(que);
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
          token,
        });
      }
    }
    await this.setLoading(false);
  }
  async searchProjects(value) {
    const { store } = this.context;
    await this.setLoadingSearch(true);
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/projects/?limit=3&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      await this.setLoadingSearch(false);
      throw new Error('Not OK');
    } else {
      await this.setLoadingSearch(false);
      const json = await res.json();
      if (json) {
        const findProjectResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id;
          newResults.title = obj.shortName;
          newResults.description = obj.state;
          if (obj.pictureKey !== '') {
            newResults.image = AWSUrl(this.props.appConfig, `${obj.pictureKey}010.jpg`);

          } else {
            newResults.image = '/assets/images/placeholder_x100.jpg';
          }
          return newResults;
        });
        this.setState({ findProjectResults });
      } else {
        const noResultsMessage = 'No results found.';
        this.setState({ noResultsMessage });
      }
    }
  }
  async submitNoetic(data) {
    await this.setLoading(true);
    const { store } = this.context;
    try {
      await store.dispatch(fetchM('/bookings/noetic/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(data),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: 'Success', message: 'Selected booking(s) has been added to the noetic synchronizing queue' }));
    this.fetchBookings();
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(replace(`/accounting/?${encodeSearch(query)}`));
    this.fetchBookings(query);
  }
  pushQuery(query) {
    const { store } = this.context;
    store.dispatch(replace(`/accounting/?${encodeSearch(query)}`));
    this.fetchBookings(query);
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.pushQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handleSearchProject = (value) => {
    clearTimeout(this.setTimer);
    // always reset results to null before finding
    const findProjectResults = [];
    const noResultsMessage = 'Loading...';
    this.setState({ findProjectResults, noResultsMessage, projectFilter: value }, () => {
      if (value !== '') {
        this.setTimer = setTimeout(() => {
          this.searchProjects(value);
        }, 500);
      }
    });
  }
  handleSelectProject = (project, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true);
  }
  handleCheckboxChange = (e, id) => {
    const { data } = this.state;
    data[id].send = !data[id].send;
    this.setState({ data });
  }
  hasSelectedItems() {
    const { data } = this.state;
    let isSelected = false;
    data.forEach((d) => {
      if (d.send) {
        isSelected = true;
      }
    });
    return isSelected;
  }
  handleSendSelected = (e) => {
    e.preventDefault();
    const { data } = this.state;
    const ids = [];
    data.forEach((d) => {
      if (d.send) {
        ids.push(d.id);
      }
    });
    this.submitNoetic(ids);
  }
  sortItems = [
    {
      text: 'Oldest Booking First',
      icon: 'sort alphabet ascending',
      sortColumn: 'booking.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Latest Booking First',
      icon: 'sort alphabet descending',
      sortColumn: 'booking.created_at',
      sortDirection: 'desc',
    },
  ];
  render() {
    const query = decodeSearch(this.props.location.search);
    const { data, loading } = this.state;
    return (
      <Container>
        <NavBar
          header="Post-Sale"
          rightNav={
            <Menu.Item fitted>
              <Button
                disabled={!this.hasSelectedItems() || loading}
                icon="check circle"
                content="Send Selected"
                color="green"
                size="medium"
                compact
                onClick={this.handleSendSelected}
              />
            </Menu.Item>
          }
        />
        <Grid verticalAlign="middle">
          <Grid.Row style={{ padding: '0' }}>
            <Grid.Column textAlign="center">
              <b>Send Booked and Sold Booking(s) To Noetic</b>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              {/* Search Filters */}
              <SearchFilter
                advanceFilter={this.state.advanceFilter}
                isLoading={this.state.loading}
                onChange={this.handleFilterOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                setAdvanceFilter={this.handleSetAdvanceFilter}
                placeholder="Search..."
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.data.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <SortButton
                    floated="right"
                    loading={this.state.loading}
                    items={this.sortItems}
                    onSort={this.handleSortData}
                  />
                )}
              >
                <SearchList
                  filterName="projectFilter"
                  icon="find"
                  isActive={(query.projectFilter && query.projectFilter.length > 0) || false}
                  loading={this.state.loadingSearch}
                  noResultsMessage={this.state.noResultsMessage}
                  onChange={this.handleSearchProject}
                  onClose={this.handleClearFilter}
                  onSelect={this.handleSelectProject}
                  placeholder="Find Project"
                  results={this.state.findProjectResults}
                  value={this.state.projectFilter}
                />
              </SearchFilter>
            </Grid.Column>
          </Grid.Row>
          {/* List Data */}
          <Grid.Row>
            <Grid.Column>
              <br className="large-hide" />
              <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                <Loader inline="centered">Loading</Loader>
              </Dimmer>
              {
                data.length > 0 ?
                  <Grid columns={2} className="equal height">
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <div style={{ overflowX: 'auto' }}>
                          <Table
                            compact
                            unstackable
                            selectable
                          >
                            <Table.Header className="mobile-hide">
                              <Table.Row>
                                <Table.HeaderCell>
                                  Date
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Booking
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Unit
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Purchaser
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">
                                  Send
                                </Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              {
                                data.map((d, idx) => (
                                  <Table.Row
                                    key={idx}
                                  >
                                    <Table.Cell>
                                      <Timestamp
                                        timestamp={d.createdAt}
                                        format="DD/M/YYYY"
                                      />
                                    </Table.Cell>
                                    <Table.Cell>
                                      <Link to={`/bookings/${d.id}/`}>
                                        {d.code}
                                      </Link>
                                    </Table.Cell>
                                    <Table.Cell>
                                      <Link title={d.code} to={`/bookings/${d.id}/`}>
                                        {d.projectUnit.reference}, {d.project.shortName}
                                        {d.projectUnit.isBumi && <Label size="mini" style={{ marginLeft: '0.5em' }}>Bumi</Label>}
                                      </Link>
                                    </Table.Cell>
                                    <Table.Cell>
                                      <Link title={d.code} to={`/bookings/${d.id}/`}>
                                        {d.bookingCustomer && d.bookingCustomer.name}
                                      </Link>
                                    </Table.Cell>
                                    <Table.Cell collapsing textAlign="center">
                                      <Checkbox
                                        toggle
                                        checked={d.send}
                                        onChange={e => this.handleCheckboxChange(e, idx)}
                                      />
                                    </Table.Cell>
                                  </Table.Row>
                                ))
                              }
                            </Table.Body>
                          </Table>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  : (
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <Item style={{}}>
                            <Item.Content>
                              {
                              !loading ?
                                <Segment textAlign="center">
                                  <p>No bookings found.</p>
                                </Segment>
                              : ''
                              }
                            </Item.Content>
                          </Item>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )
                }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default connect(Accounting.mapStateToProps)(Accounting);




// WEBPACK FOOTER //
// ./src/containers/Accounting/Accounting.jsx